export default {
  lang: {
    selectAll: 'ជ្រើស ទំព័រ ទាំងអស់',
    selected: 'បាន ជ្រើស',
    term: 'អត្ថបទ',
    deselect: 'ដោះ ជ្រើស',
  },
};
